<template>
    <DModal
        :title="__(`tools.sms.samples.${contentSubject}.${contentSubject}`)"
        :show="showModal"
        close-color-secondary
        is-big
        overflow-auto
        @close="closeModal"
    >
        <DTabs>
            <DTabItem
                :label="__('tools.sms.preview_modal.tabs.plain_text')"
                :active="currentTab === 0"
                @click="changeTab(0)"
            />
            <DTabItem
                :label="__('tools.sms.preview_modal.tabs.send_copy')"
                :active="currentTab === 1"
                @click="changeTab(1)"
            />
        </DTabs>

        <DCard
            v-if="currentTab === 0"
        >
            <div
                v-if="contentData !== ''"
                class="m-5 content-data"
            >
                {{ contentData }}
            </div>

            <div
                v-if="errorsString !== null"
                class="text-danger m-5"
            >
                {{ errorsString }}
            </div>
        </DCard>

        <DCard
            v-if="currentTab === 1"
            class="p-2"
        >
            <DFormRow
                class="mb-2"
                is-vertical
                :label="__('tools.sms.preview_modal.phone_number')"
            >
                <DInput
                    id="phone_number"
                    v-model="form.phoneNumber"
                    @update:value="validatePhoneNumber"
                />
            </DFormRow>
            <DButton
                :label="__('tools.sms.preview_modal.send_copy')"
                :disabled="!phoneNumberValid"
                class="my-2"
                color="primary"
                @click="submitSendCopy"
            />
            <div
                v-if="messageSent !== null"
            >
                <p
                    v-if="messageSent === true"
                    class="text-success text-center"
                >
                    Message sent!
                </p>
                <p
                    v-else
                    class="text-danger text-center"
                >
                    {{ sendMessageError }}
                </p>
            </div>
        </DCard>
    </DModal>
</template>

<script setup>
import { ref, watch } from 'vue'

import { route } from '~@/Composables/route'
import { useForm } from '@inertiajs/vue3'
import { isValidPhoneNumber } from 'libphonenumber-js'

const emit = defineEmits(['closeModal'])

const props = defineProps({
    showModal: {
        type: Boolean,
        default: () => ref(false)
    },
    customer: {
        type: Object,
        default: () => {
            return {}
        }
    },
    smsId: {
        type: Number,
        default: 0
    }
})

const phoneNumberValid = ref(false)
const messageSent = ref(null)
const sendMessageError = ref(null)

const currentTab = ref(0)
const previewCompleted = ref(false)
const contentSubject = ref('')
const contentData = ref('')

const errorsString = ref(null)

const form = useForm({
    customer: props.customer,
    sms_archive: props.smsId,
    phoneNumber: ''
})

function changeTab (tabIndex) {
    currentTab.value = tabIndex
}

function closeModal () {
    previewCompleted.value = false
    errorsString.value = null
    currentTab.value = 0
    emit('closeModal')
}

function nl2br (content) {
    return content.replace(/\n/g, '<br>')
}

function validatePhoneNumber () {
    phoneNumberValid.value = isValidPhoneNumber(form.phoneNumber)
}

function submitSendCopy () {
    window.axios.post(route('customers.customers.sms-archives.resend', form))
        .then(() => {
            messageSent.value = true
        })
        .catch((error) => {
            sendMessageError.value = error.response.data.errors.general[0]
            messageSent.value = false
        })
}

function getContent () {
    window.axios.get(route('customers.customers.sms-archives.show', {
        sms_archive: props.smsId,
        customer: props.customer.id
    }))
        .then(response => {
            form.sms_archive = response.data.sms_archive.id
            contentData.value = nl2br(response.data.sms_archive.data)
            contentSubject.value = response.data.sms_archive.subject

            previewCompleted.value = true
        })
        .catch((error) => {
            const errors = []
            const errorObject = error.response && error.response.data && error.response.data.errors
                ? error.response.data.errors
                : {}
            Object.keys(errorObject).forEach((field) => {
                errorObject[field].forEach((message) => {
                    errors.push(message)
                })
            })

            errorsString.value = errors.join(', ')
        })
}

watch(
    () => props.showModal,
    () => {
        getContent()
    }
)

</script>

<style>
.content-data {
    min-height: 6vh;
    min-width: 30vw;
}
</style>
